import React from 'react'
import { Auth0Service, LocalStorageService, UserService, ContractService, SessionService, ClientService } from '../services'
import { SimpleLoading } from './pures'
import { AppAction, LoginAction, OnboardingUserAction, ChangePasswordEmailAction, OnboardingAction } from './actions'
import i18n from '../i18n'

/**
 * @class IndexComponent
 * @extends {React.Component}
 * @status no delete
 * @description Component that defines the action of user when initially starting application.
 */
class IndexComponent extends React.Component {
  state = {
    isLoading: false,
    isLogged: false,
    emailConfirmed: true,
    userRegistered: false,
    userIsInvited: false,
    userInvitedUpdateYourInfo: true,
    userIsColaborator: false,
    userColaboratorUpdateYourInfo: true,
    userInviteIsCreatingContract: false,
    unauthorized: false,
    userLogin: '',
    userStartSesion: false,
    loading: false,
    showLoadingRequesting: false,
    showCompletedRequesting: false,
    showErrorRequesting: false,
    showNotification: false,
    showRegisterCompleted: false,
    notificationStatus: 'success',
    canSendEmail: false,
    timerSesion: {},
    isEmailChangepassword: false,
    tokenEmailChange: '',
    userEmailChange: '',
    isQRDocsigned: false,
    contractInactive: false,
    sessionIdQR: '',
    hashQR: '',
    onboardingUser: false,
    tokenInfoOnboardingUser: '',
    userEmailOnboarding: ''
  }

  auth0Service = new Auth0Service()
  localStorageService = new LocalStorageService()
  userService = new UserService(process.env.REACT_APP_ETICKET_API)
  contractService = new ContractService(process.env.REACT_APP_ETICKET_API)
  sessionService = new SessionService(process.env.REACT_APP_ETICKET_API)
  clientService = new ClientService(process.env.REACT_APP_ETICKET_API)

  /* ===== Styles of notification alert component ===== */
  notification = {
    type: {
      style: this.state.notificationStatus,
      icon: true
    },
    style: {
      bottom: 85,
      right: 30,
      position: 'fixed'
    }
  }

  /* ===== Handler function for only close the notification ===== */
  onCloseOpenModal = () => {
    this.setState({
      showNotification: false,
      showCompletedRequesting: false,
    })
  }

  /* ===== Handler function for open and close the the notification with a timeOut ===== */
  handleMessage = (message) => {
    this.setState({
      // showNotification: true,
      showCompletedRequesting: true,
      message
    }, () => {
      setTimeout(() => {
        this.onCloseOpenModal()
      }, 5000)
    })
  }

  toggleCompletedRequesting = (value) => {
    this.setState({
      showCompletedRequesting: value
    }, () => {
      setTimeout(() => {
        this.setState({ showCompletedRequesting: false })
      }, 4000)
    })
  }

  toggleLoadingRequesting = (value) => {
    this.setState({
      showLoadingRequesting: value
    })
  }

  toggleErrorRequesting = (value) => {
    this.setState({
      showErrorRequesting: value,
    },
      () => {
        setTimeout(() => {
          this.setState({ showErrorRequesting: false })
        }, 4000)
      }
    )
  }

  /**
  * @author Alan Aguilar
  * @description Method to show the register completed dialog modal
  * @updatedDate 03-08-2021
  * @memberof SignatureRequestAction
  */
  toggleRegisterCompleted = (value) => {
    this.setState({ showRegisterCompleted: value })
    if (value === false) return this.onGoToMenu()
  }

  /**
  * @author Alan Aguilar
  * @description Redirect the user to the menu rechangin the page
  * @updatedDate 03-08-2021
  * @memberof SignatureRequestAction
  */
  onGoToMenu = () => {
    window.location.reload()
  }

  /**
   * @author Leonel Contreras
   * @description redirect to login
   * @memberof IndexAction
   */
  redirectLogin = async () => {
    let logo = await this.localStorageService.getLocalStorageItem('clientLogo')
    let promotion = await this.localStorageService.getLocalStorageItem('promotion')
    this.localStorageService.clearLocalStorage()
    this.localStorageService.setLocalStorageItem('clientLogo', logo)
    if (promotion) {
      this.localStorageService.setLocalStorageItem('promotion', promotion)
    }
    this.setState({ userStartSesion: false })
  }

  /**
  * @author Alan Aguilar
  * @description Set the state userRegistered to true to authorize the user register
  * @updatedDate 03-08-2021
  * @memberof IndexAction
  */
  onRegisterEnd = () => {
    console.log('onRegiserEnd')
    // this.setState({ userRegistered: true })
  }

  onLoadEmailConfirmation = async () => {
    try {
      let user = this.localStorageService.getLocalStorageItem('user')
      let token = this.localStorageService.getLocalStorageItem('token')
      let userAuth0Id = user.userMetaData.userAuth0.user_id.split('|')[1]
      let emailVerification = await this.sessionService.sessionEmailVerification(userAuth0Id, token.idToken)
      if (!emailVerification) return
      return true
    } catch (error) {
    }
  }

  /**
   * @author Leonel Contreras
   * @description send an email confirmation if the user has token
   * @param {boolean} sendEmail
   */
  onSendVerificationEmail = async (sendEmail) => {
    try {
      this.toggleLoadingRequesting(true)
      if (sendEmail) {
        let user = this.localStorageService.getLocalStorageItem('user')
        let token = this.localStorageService.getLocalStorageItem('token')
        let userAuth0Id = user.userMetaData.userAuth0.user_id.split('|')[1]
        await this.sessionService.sessionEmailVerification(userAuth0Id, token.idToken)
        this.toggleLoadingRequesting(false)
        this.toggleCompletedRequesting(true)
      } else {
        window.location.reload()
      }
    } catch {
      this.toggleLoadingRequesting(false)
      this.toggleErrorRequesting(true)
      return false
    }
  }

  /**
  * @author Alan Aguilar
  * @description Redirect a invited user to register
  * @date 24-02-2021
  * @memberof IndexAction
  */
  onInvitedRedirectRegister = () => {
    this.setState({
      userRegistered: false,
      userIsInvited: false
    })
  }

  async componentDidMount() {
    this.setState({ loading: true })

    let location = window.location

    // Check if the URL contains an invitation token (user clicked the email link)
    const urlParams = new URLSearchParams(location.search)
    const urlTokenValue = urlParams.get('token')
    const urlTypeValue = urlParams.get('type')
    const comingFromInvitationLink = !!(urlTokenValue && urlTypeValue)

    // If there's a pending registration but we are NOT coming from the invitation link,
    // clear the existing session and send to login with a warning
    const pendingOnboarding = this.localStorageService.getLocalStorageItem('pendingOnboardingToken')
    if (pendingOnboarding && !comingFromInvitationLink) {
      const clientLogo = this.localStorageService.getLocalStorageItem('clientLogo')
      const language = this.localStorageService.getLocalStorageItem('i18nextLng', false)
      this.localStorageService.clearLocalStorage()
      this.localStorageService.setLocalStorageItem('pendingOnboardingToken', pendingOnboarding)
      if (clientLogo) this.localStorageService.setLocalStorageItem('clientLogo', clientLogo)
      if (language) this.localStorageService.setLocalStorageItem('i18nextLng', language)
      this.setState({ loading: false, showPendingRegistrationWarning: true })
      return
    }
    let myStorage = window.localStorage

    const tabSelected = {
      buttonFilterSelectedBlue: 'table-button-blue-active',
      buttonFilterSelectedGreen: '',
    }

    myStorage.setItem('tabSelected', JSON.stringify(tabSelected))
    myStorage.setItem('tabSelectedReq', JSON.stringify(tabSelected))
    this.setState({ isLoading: true })

    // Save the signRequest url if exist
    let signRequestHash = location.href.split('#')[1]
    let urlIsFromSignRequest = (signRequestHash !== undefined || signRequestHash !== '/' || signRequestHash !== '') ? true : false
    if (urlIsFromSignRequest) this.localStorageService.setLocalStorageItem('url', location.href)

    let token = this.localStorageService.getLocalStorageItem('token')
    let user = this.localStorageService.getLocalStorageItem('user')
    let modules = this.localStorageService.getLocalStorageItem('modules')
    let userToken = null
    let userMetaData = null

    // //Verify if is an email to change password
    // let infoTokenInUrl = location.href.split('?')[1]
    // let existInfoTokenInUrl = (infoTokenInUrl !== undefined && infoTokenInUrl !== '' && infoTokenInUrl.includes('token=')) ? true : false
    const queryParams = new URLSearchParams(location.search);

    // Extrae el valor de 'token' y 'type'
    const tokenValue = queryParams.get('token');
    const typeValue = queryParams.get('type');
    const emailValue = queryParams.get('email')

    if (tokenValue) {
      // Logic to verify if is change password user or onboarding user
      let stateToChange = {}
      if (typeValue) {
        // Clear any existing session so the invitation token from the URL
        // is not overridden by the axios interceptor using localStorage credentials
        const clientLogo = this.localStorageService.getLocalStorageItem('clientLogo')
        const language = this.localStorageService.getLocalStorageItem('i18nextLng', false)
        this.localStorageService.clearLocalStorage()
        this.localStorageService.setLocalStorageItem('pendingOnboardingToken', { token: tokenValue, email: emailValue })
        if (clientLogo) this.localStorageService.setLocalStorageItem('clientLogo', clientLogo)
        if (language) this.localStorageService.setLocalStorageItem('i18nextLng', language)
        token = null
        user = null
        modules = null

        stateToChange = {
          onboardingUser: true,
          tokenInfoOnboardingUser: tokenValue,
          userEmailOnboarding: emailValue,
          loading: false
        }
        this.setState(stateToChange)
        return
      } else {
        stateToChange = {
          isEmailChangepassword: true,
          tokenInfoChangePassword: tokenValue
        }
      }

      this.setState(stateToChange)
    }

    try {
      if (token && user && modules !== null) {
        // If a token exist, get user information from A3Cloud API and DigitalSignApp API
        if (process.env.REACT_APP_AUTH_OPTION === process.env.REACT_APP_AUTH_OPTION_AUTH0) userToken = await this.auth0Service.getUserProfile(token.accessToken)
        const authId = user.userToken ? user.userToken.sub : '123'
        userMetaData = await this.userService.getUser(authId, token.idToken)

        if (userMetaData == null) {
          this.setState({ isLogged: true, userRegistered: false, loading: false })
          return false
        }
        if (userMetaData.userA3Cloud === null || userMetaData.userMifirma === null) {
          this.setState({ isLogged: true, userRegistered: false, loading: false, userStartSesion: true })
          return false
        }

        // Start Local Storge

        user.userMetaData = userMetaData
        if (userMetaData) {
          modules = (userMetaData.userModules ? userMetaData.userModules : null)
          this.localStorageService.startLocalStorage(token, user, modules)
        }
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        this.localStorageService.setLocalStorageItem('timezone', timezone)
        if (userMetaData) {
          this.setState({ emailConfirmed: userMetaData.userAuth0.email_verified })
          let contract = await this.contractService.validateContractUser(token.idToken)
          if (contract && contract.data && contract.data?.userHadContracts) {
            this.localStorageService.setLocalStorageItem("contractUserExist", contract);
          }

          // Validate if the user has almost one contract
          if (contract.data && (contract.data.contractExist === true || contract.data.userHadContracts === true)) {
            this.setState({ userRegistered: true })
          }
          this.setState({ userLogin: userMetaData.userA3Cloud.email, userStartSesion: true })
        }

        // Timer token session started
        this.localStorageService.timerSession(token)

        this.setState({ isLogged: true, loading: false })
        window.history.pushState('', document.title, window.location.pathname)

      } else if (token) {
        if (token.accessToken) {
          if (process.env.REACT_APP_AUTH_OPTION === process.env.REACT_APP_AUTH_OPTION_AUTH0) userToken = await this.auth0Service.getUserProfile(token.accessToken)
          const authId = userToken ? userToken.sub : '123'
          userMetaData = await this.userService.getUser(authId, token.idToken)

          if (userMetaData) {
            this.setState({ emailConfirmed: userMetaData.userAuth0.email_verified, userStartSesion: true, canSendEmail: true })
            let contract = await this.contractService.validateContractUser(token.idToken)
            if (contract && contract.data && contract.data?.userHadContracts) {
              this.localStorageService.setLocalStorageItem("contractUserExist", contract);
            }
            if (contract.data?.contractsStatus === 1) {
              this.setState({ contractInactive: true })
            }

            if (userMetaData.userRoles.length !== 0) {
              if (['generalAdministrator', 'generalUser'].includes(userMetaData.userRoles[0].role.key)) {
                this.setState({ userIsColaborator: true })
                // Check if the user has updated your information
                let { firstName, firstLastName, secondLastName, phoneNumber, cellphoneNumber } = userMetaData.userA3Cloud
                if (((firstName === '') &&
                  (firstLastName === '') &&
                  (secondLastName === '') &&
                  (phoneNumber === null || phoneNumber === '') &&
                  (cellphoneNumber === null || cellphoneNumber === ''))) {
                  this.setState({ userColaboratorUpdateYourInfo: false })
                }
              }
            }

            // Timer token session started
            this.localStorageService.timerSession(token)
            window.history.pushState('', document.title, window.location.pathname)

            if (contract && contract.data) {
              if (contract.data.contractExist === true || contract.data.userHadContracts === true) {
                this.setState({ userRegistered: true })
              }
            }

            // Save the user information of Logo
            let clientLogo = await this.clientService.getClientImage(token.idToken)
            if (clientLogo && clientLogo.data && clientLogo.data.image) {
              this.localStorageService.setLocalStorageItem('clientLogo', clientLogo.data.image)
            } else {
              this.localStorageService.setLocalStorageItem('clientLogo', null)
            }

            this.setState({ emailConfirmed: userMetaData.userAuth0.email_verified, userStartSesion: true })
            this.setState({ userLogin: userMetaData.userAuth0.email, loading: false })
          }
        } else {
          this.setState({ userLogin: token.email, loading: false })
          let logo = await this.localStorageService.getLocalStorageItem('clientLogo')
          let promotion = await this.localStorageService.getLocalStorageItem('promotion')
          this.localStorageService.clearLocalStorage()
          if (logo) this.localStorageService.setLocalStorageItem('clientLogo', logo)
          if (promotion) this.localStorageService.setLocalStorageItem('promotion', promotion)
          this.setState({ userStartSesion: true, emailConfirmed: false })
        }

        let user = {}
        user.userToken = userToken
        user.userMetaData = userMetaData
        // userMetaData.userModules does not exist, need to update
        if (userMetaData) {
          modules = (userMetaData.userModules ? userMetaData.userModules : null)
          this.localStorageService.startLocalStorage(token, user, modules)
        }
        else {
          modules = null
          this.localStorageService.startLocalStorage(null, user, modules)
        }

        if (user.userMetaData.userA3Cloud.language) i18n.changeLanguage(user.userMetaData.userA3Cloud.language.name)
        this.setState({ isLogged: true, loading: false })
      } else {
        this.redirectLogin()
        this.setState({ loading: false })
      }
    } catch (err) {
      this.redirectLogin()
      this.setState({ loading: false })
    }
  }

  handleButtonLogOut = async () => {
    let logo = await this.localStorageService.getLocalStorageItem('clientLogo')
    let promotion = await this.localStorageService.getLocalStorageItem('promotion')
    this.localStorageService.clearLocalStorage()
    this.localStorageService.setLocalStorageItem('clientLogo', logo ? logo : '')
    if (promotion) this.localStorageService.setLocalStorageItem('promotion', promotion ? promotion : '')
  }


  render() {
    if (this.state.loading === true) {
      return <div className="loading">
        <SimpleLoading />
      </div>
    } else if (this.state.onboardingUser) {
      return <OnboardingUserAction
        email={this.state.userEmailOnboarding}
        token={this.state.tokenInfoOnboardingUser} />
    } else if (this.state.isEmailChangepassword === true) {
      return <ChangePasswordEmailAction
        user={this.state.userInfoChangePassword}
        token={this.state.tokenInfoChangePassword}
      />
    } else if (this.state.userStartSesion === false) {
      return <LoginAction showPendingRegistrationWarning={this.state.showPendingRegistrationWarning} />
    }
    else if (this.state.userStartSesion === true &&
      this.state.isLogged &&
      this.state.userRegistered === false &&
      this.state.userIsInvited === false &&
      this.state.userIsColaborator === false) {
      return <OnboardingAction />
    }
    else if (this.state.userStartSesion === true &&
      this.state.isLogged && this.state.userRegistered) { // check validation for the this.state.userRegister
      return <AppAction
        onInvitedRedirectRegister={this.onInvitedRedirectRegister}
      />
    } else if (this.state.unauthorized) {
      return <div>unauthorized</div>
    } else {
      return <div className="loading">
        <SimpleLoading />
      </div>
    }
  }
}

export { IndexComponent as default }